import type { TouchpointSourceType } from '../TouchpointSourceType';

export type CrossFlowExperience =
  | 'allUsersExperience'
  | 'freeExistingUserExperience'
  | 'jiraWorkItemCreationExperience'
  | 'newUserExperience'
  | 'paidUsersExperience';

const experiencePlacements: Record<
  CrossFlowExperience,
  TouchpointSourceType[]
> = {
  allUsersExperience: ['memberBoardsHomeScreen', 'workspaceBoardsHomeScreen'],
  newUserExperience: [
    'currentWorkspaceNavigationDrawer',
    'memberBoardsHomeScreen',
    'workspaceBoardsHomeScreen',
  ],
  freeExistingUserExperience: [
    'boardScreen',
    'memberBoardsHomeScreen',
    'workspaceBoardsHomeScreen',
  ],
  paidUsersExperience: [
    'boardDirectory',
    'boardScreen',
    'memberBoardsHomeScreen',
    'workspaceBoardsHomeScreen',
  ],
  jiraWorkItemCreationExperience: [
    'cardDetailScreen',
    'featureAnnouncementModal',
    'quickCardEditorInlineDialog',
    'joinOrCreateChoiceDialog',
  ],
};

export const isSourceTargetedByExperience = (
  experience: CrossFlowExperience,
  source: TouchpointSourceType,
): boolean => {
  return experiencePlacements[experience].includes(source);
};
